import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NotificationBell from '../../components/NotificationBell';
import { getMyTeamProfile } from '../../services/teamProfileApi';

// Iniciales como respaldo cuando no hay foto subida — mismo patrón que
// AdminTeam.js, para que el círculo nunca se vea vacío.
const initialsFrom = (name) => (name || '').trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || '').join('') || '?';

// Barra superior delgada — en PC vive a la derecha del sidebar (el padding
// izquierdo lo pone el contenedor en AdminRoutes) y solo carga la campana; el
// logo/título de ahí ya lo muestra el sidebar. En móvil sí trae el logo,
// porque ahí no hay sidebar visible.
const AdminTopBar = () => {
  const [me, setMe] = useState(null);
  useEffect(() => {
    let cancelled = false;
    getMyTeamProfile().then((res) => { if (!cancelled) setMe(res); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  const displayName = me?.profile?.displayName || me?.user?.name || '';
  const imageUrl = me?.profile?.imageUrl || '';

  return (
    <header className="sticky top-0 z-30 flex h-16 flex-shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4 md:px-6">
      <Link to="/admin/dashboard" className="flex items-center gap-2 md:hidden">
        <img src="/logo-bbts.png" alt="BBTS" className="h-8 w-auto" />
        <span className="text-base font-semibold text-gray-800">Panel Admin</span>
      </Link>
      <div className="ml-auto flex items-center gap-3">
        <NotificationBell />
        <Link to="/admin/profile" title={displayName || 'Mi perfil'} className="flex-shrink-0">
          {imageUrl ? (
            <img src={imageUrl} alt={displayName || 'Mi perfil'} className="h-9 w-9 rounded-full border border-gray-200 object-cover" />
          ) : (
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-orange-100 text-xs font-bold text-orange-700">{initialsFrom(displayName)}</span>
          )}
        </Link>
      </div>
    </header>
  );
};

export default AdminTopBar;
